import React from "react";
import * as c from "./lcFooter.module.scss";
import { MangomintLogo } from "@components/ui/mangomintLogo";

export default function LcFooter() {
  return (
    <footer className={c.footer}>
      <hr></hr>
      <MangomintLogo className={c.logo} />
      <p className={c.copyright}>© Mangomint, Inc. All rights reserved.</p>
    </footer>
  );
}
